import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './SidebarMenu.module.scss';
import { TSidebarMenuProps } from './definitions';
import { joinClassnames } from 'helpers/classNames';
import { connect } from 'react-redux';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';
import CategoryList from './Components/Organisms/CategoryList';
import CategoryListDetail from './Components/Organisms/CategoryListDetail';
import AuthInfo from '../SidebarMenu/Components/Molecules/AuthInfo';

function SidebarMenuComponent({ show, hide, dataAuth }: TSidebarMenuProps) {
  const { onMenuDetail } = React.useContext(SidebarMenuContext);
  return (
    <>
      <div
        className={joinClassnames(
          Styles['sidebar-menu'],
          show ? Styles['sidebar-menu--show'] : '',
        )}
      >
        <div
          className={joinClassnames(
            Styles['category-list'],
            !onMenuDetail ? Styles['category-list--show'] : '',
          )}
        >
          <CategoryList dataAuth={dataAuth} />
        </div>
        <div
          className={joinClassnames(
            Styles['category-list-detail'],
            onMenuDetail ? Styles['category-list-detail--show'] : '',
          )}
        >
          <CategoryListDetail dataAuth={dataAuth} />
        </div>
        <AuthInfo dataAuth={dataAuth} />
      </div>
      <div
        className={joinClassnames(
          Styles['sidebar-menu-overlay'],
          show ? Styles['sidebar-menu-overlay--show'] : '',
        )}
        onClick={hide}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
});

export default connect(mapStateToProps)(SidebarMenuComponent);
